// src/NavPages/Login.js
import React, { useState, useEffect } from 'react';
import { signInWithEmailAndPassword } from 'firebase/auth';
import { useNavigate, useLocation } from 'react-router-dom';
import { auth } from '../firebase';
import { useAuth } from '../context/AuthContext';
import SiteHeader from '../Views/SiteHeader';
import ContactFooter from '../Components/ContactFooter';

const Login = () => {
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const { currentUser } = useAuth();
  
  // Fixed email for authentication
  const fixedEmail = "access@example.com";
  const correctPassword = "access123";

  // If user is already logged in, redirect them
  useEffect(() => {
    if (currentUser) {
      const destination = location.state?.from?.pathname || '/healthcare';
      navigate(destination, { replace: true });
    }
  }, [currentUser, navigate, location]);

  const from = location.state?.from?.pathname || '/healthcare';

  const handleLogin = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    
    // Check if password matches the fixed password
    if (password === correctPassword) {
      try {
        // Use the fixed email with the entered password
        await signInWithEmailAndPassword(auth, fixedEmail, password);
        navigate(from, { replace: true });
      } catch (error) {
        setError('Authentication error. Please contact the administrator.');
        console.error(error);
      } finally {
        setLoading(false);
      }
    } else {
      setError('Incorrect password');
      setLoading(false);
    }
  };

  return (
    <div style={{ minHeight: '100vh', backgroundColor: 'var(--color-bg)' }}>
      <SiteHeader />

      <main
        style={{
          padding: 'calc(var(--header-height) + 28px) var(--page-inset) 100px',
          maxWidth: '1700px',
          margin: '0 auto',
          fontFamily: 'var(--font-sans)',
          color: 'var(--color-fg)',
        }}
      >
        <h1
          style={{
            margin: '0 0 20px',
            fontFamily: 'var(--font-sans)',
            fontSize: '33px',
            fontWeight: 'var(--fw-medium)',
            lineHeight: 1.1,
            letterSpacing: 'normal',
          }}
        >
          Protected Content Access
        </h1>
        <hr
          style={{
            border: 'none',
            borderTop: '1px solid var(--color-rule)',
            margin: '0 0 24px',
          }}
        />
        <p
          style={{
            margin: '0 0 24px',
            fontFamily: 'var(--font-sans)',
            fontSize: 'var(--fs-small)',
            lineHeight: 'var(--lh-small)',
            fontWeight: 'var(--fw-regular)',
          }}
        >
          Enter the password to view content.
        </p>
        {error && (
          <div
            style={{
              color: '#c0392b',
              marginBottom: '1rem',
              fontFamily: 'var(--font-sans)',
              fontSize: 'var(--fs-small)',
              lineHeight: 'var(--lh-small)',
              fontWeight: 'var(--fw-regular)',
            }}
          >
            {error}
          </div>
        )}
        <form onSubmit={handleLogin} style={{ maxWidth: '320px' }}>
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="Password"
            required
            style={{
              display: 'block',
              marginBottom: '1rem',
              width: '100%',
              padding: '0.6rem 0.75rem',
              fontFamily: 'var(--font-sans)',
              fontSize: 'var(--fs-small)',
              fontWeight: 'var(--fw-regular)',
              color: 'var(--color-fg)',
              backgroundColor: 'transparent',
              border: '1px solid var(--color-rule)',
              borderRadius: 0,
            }}
          />
          <button
            type="submit"
            disabled={loading}
            style={{
              padding: '0.6rem 1.25rem',
              backgroundColor: 'var(--color-fg)',
              color: '#fff',
              border: 'none',
              borderRadius: 0,
              cursor: loading ? 'not-allowed' : 'pointer',
              opacity: loading ? 0.7 : 1,
              fontFamily: 'var(--font-sans)',
              fontSize: 'var(--fs-small)',
              fontWeight: 'var(--fw-medium)',
              letterSpacing: '0.02em',
              textTransform: 'uppercase',
            }}
          >
            {loading ? 'Accessing...' : 'Access Content'}
          </button>
        </form>
      </main>

      <ContactFooter />
    </div>
  );
};

export default Login;